import { Button, Layout, Spin } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { deleteRequest, get, post } from '../../Common/api'
import { PlusOutlined } from '@ant-design/icons'
import IntervenerForm from '../IntervenerPage/IntervenerForm'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
import IntervenerFilter from './IntervenerFilter'
import { Color } from '../../Common/Color'
import IntervenersTab from './IntervenersTab'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import CustModal from '../../Common/CustModal'
import GlobalContext from '../GlobalContext'
import { ActionButton } from '../../Common/Common'

export default function IntervenersPage () {
  const [activeInterveners, setActiveInterveners] = useState([])
  const [deletedInterveners, setDeletedInterveners] = useState([])
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState({ name: '', box_id: '', job: 'all' })
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()
  const screens = useBreakpoint()
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getInterveners()
  }, [])

  const formatIntervener = (intervener) => (
    {
      ...intervener,
      key: intervener.id,
      phones: (intervener.phones.map(phone => ({ ...phone, value: `+${phone.value}`, key: phone.id }))),
      emails: (intervener.emails.map(email => ({ ...email, key: email.id })))
    }
  )

  const getInterveners = async () => {
    setLoading(true)
    await get({
      url: 'admin/interveners',
      params: {},
      onSuccess: (res) => {
        setActiveInterveners([...res.active.map(i => formatIntervener(i))])
        setDeletedInterveners([...res.deleted.map(i => formatIntervener(i))])
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const onChangeFilter = (filter) => {
    setFilter(filter)
  }

  const openFormModal = (intervener) => {
    form.resetFields()
    if (intervener) {
      form.setFieldsValue(intervener)
    }
    setModalVisible(true)
  }

  const addRequest = async (values) => {
    setLoading(true)
    await post({
      url: 'admin/interveners',
      params: values,
      notification: { api: notificationApi, state: 'create' },
      onSuccess: (res) => {
        setActiveInterveners([...activeInterveners, formatIntervener(res)])
        setLoading(false)
        setModalVisible(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const deleteIntervener = async (intervener) => {
    await deleteRequest({
      url: `admin/interveners/${intervener.id}`,
      params: {},
      notification: { api: notificationApi, state: 'delete' },
      onSuccess: (res) => {
        const intervener = activeInterveners.find(i => i.id === res.id)
        setActiveInterveners(activeInterveners.filter(i => i.id !== res.id))
        setDeletedInterveners([...deletedInterveners, intervener])
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const filteredInterveners = (interveners) => {
    return interveners.filter((intervener) => {
      return intervener.name.toLowerCase().includes(filter.name.toLowerCase()) &&
        (!filter.box_id || intervener.boxes.map(box => box.id).includes(filter.box_id)) &&
        (filter.job === 'all' || intervener.job.includes(filter.job))
    })
  }

  return (
    <Layout style={{ marginTop: '1em' }} >
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{activeInterveners.length + deletedInterveners.length}</b> {t('Admin.BoxesPage.title')}</div>
          { !screens.xs && <IntervenerFilter filter={filter} onChangeFilter={onChangeFilter} /> }
          <ActionButton onClick={() => openFormModal()} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        <IntervenersTab
          activeInterveners={filteredInterveners(activeInterveners)}
          deletedInterveners={filteredInterveners(deletedInterveners)}
          deleteIntervener={deleteIntervener}
        />
        <CustModal
          open={modalVisible}
          setOpen={setModalVisible}
          width="1000px"
          title={t('Admin.IntervenersPage.addIntervenerTitle')}
          confirmLoading={loading}
          onOk={form.submit}
        >
          <Spin spinning={loading}>
            <IntervenerForm form={form} action="add" addRequest={addRequest} />
          </Spin>
        </CustModal>
      </Spin>
    </Layout >
  )
}
